import React from "react";
import * as S from "./FlorenzFieldForm.style.js";
import FlorenzInput from "../florenzInput";
import Popup from "reactjs-popup";
import { PopUpPayload } from "../../private/outcomes/components/outcomesComponents/shared/genericTemplate/GenericTemplate.style.js";
import ZaiaSelectForm from "../../zaiaComponents/zaiaSelectForm";

function  FlorenzFieldForm({ 
  label,
  value,
  required,
  disabled,
  description,
  getText,
  options,
  ...props
}) {  

  return (
    <S.FlorenzFieldForm>
       <div className="selection-container">
          <div className="title">
            <div className="title__text">
              {label}
            </div>
            {
              value
              ? <i className="title__icon icon zaia-i-check-1"></i>
              : <div className="title__required error">{required && "*"}</div>
            }
            {
              description &&
              <Popup
                trigger={
                  <i className="title__icon-payload icon zaia-alert"></i>
                }
              on={['hover', 'focus']}
              closeOnDocumentClick
              keepTooltipInside
              position={['right center']}
              nested
            >
              <PopUpPayload>
                <p>
                {description}
                </p>
              </PopUpPayload>
            </Popup>
            }     
          </div>
          <div className="input-container">
            {
              !options &&
              <FlorenzInput
                value={value}
                getText={getText}
                type={"text"}
                disabled={disabled}
              />
            }
            {
              options &&
              <ZaiaSelectForm
                type="select"
                name="typeDocument"
                borderRadius={"20px"}
                fontSize={"20px"}
                padding={"22px 24px 17px 27px"}
                borderColor={"#DADAFD"}
                fontFamily={"Nunito Sans Bold"}
                textColor={"#3E3DA3"}
                disabledColor={"#EDEDFF"}
                onlyBottomBorder
                disabledtextcolor={"#53536B"}
                disabledIconColor={"#878792"}
                backgroundColor={"#F0F0FF"}
                value={value}
                getText={getText}
                items={
                  options?.map((type) => {
                    return ({
                      value: type.value,
                      text: type.comment?.code
                    })
                  })
                }
                {...props}
              />
            }
          </div>
        </div>
    </S.FlorenzFieldForm>
  );
}

export default FlorenzFieldForm;
